import Slider from "react-slick";

const LONG_DESCRIPTION =
  "This modern and interactive school website is designed to provide students, parents, and staff with seamless access to essential information. Built with React.js, it ensures a fast, responsive, and engaging user experience. From admission details to event updates, the website serves as a central hub for all school-related activities.";

const SHORT_DESCRIPTION =
  "Fully responsive and optimized website template designed for modern institutions. Built with React.js ensuring smooth performance and seamless browsing experience across all devices.";

const LONG_GENERAL_FEATURES = [
  {
    label: "Fast & Responsive",
    text: "Optimized for speed and mobile responsiveness.",
  },
  { label: "Modern UI/UX", text: "Clean and user-friendly design." },
  {
    label: "SEO-Friendly",
    text: "Built with SEO best practices for better search rankings.",
  },
  {
    label: "Cross-Browser Compatibility",
    text: "Works seamlessly on all major browsers.",
  },
];

const SHORT_GENERAL_FEATURES = [
  { label: "Fast & Responsive", text: "Optimized performance." },
  { label: "Modern UI/UX", text: "Clean and elegant layout." },
  { label: "SEO-Friendly", text: "Search engine optimized." },
  { label: "Cross-Browser Compatible", text: "Works on all devices." },
];

const PERFORMANCE_FEATURES = [
  {
    label: "Lazy Loading",
    text: "Loads components dynamically for better performance.",
  },
  {
    label: "Code Splitting",
    text: "Improves loading speed by splitting code into smaller bundles.",
  },
  {
    label: "Optimized Images",
    text: "Uses WebP and optimized images for faster loading.",
  },
  {
    label: "Server-Side Rendering",
    text: "Faster page load and better SEO with frameworks like React JS.",
  },
];

const FUNCTIONAL_FEATURES = [
  {
    label: "Multi-Language Support",
    text: "Available in multiple languages. (Optional)",
  },
  {
    label: "Authentication System",
    text: "Secure login, signup, and user authentication with JWT or Firebase.",
  },
  {
    label: "Admin Dashboard",
    text: "Fully functional admin panel for content and user management.",
  },
];

const DYNAMIC_SECTIONS = [
  "Highlight Scrolling",
  "Online Registration Blink Link",
  "Latest News",
  "Upcoming Events",
  "Admission Enquiry",
  "Photo Gallery",
  "Toppers Of Xth Class",
  "Toppers Of XIIth Class",
  "Message of Management",
  "Academic Calender",
];

const STATIC_SECTIONS = [
  "Header",
  "Main Slider",
  "Important Tabs",
  "About Us",
  "Useful Links and Important Links",
  "Social Media widgets(Optional)",
  "Footer",
];

const TemplatePopup = ({
  isOpen,
  onClose,
  settings,
  colorTheme,
  onColorSelect,
  imgContainerRef,
  isFullscreen,
  onOpenFullscreen,
  template,
}) => {
  if (!isOpen) return null;

  const templateCode = template.templateCode?.trim() || "N/A";
  const themeIndex = Number(colorTheme) - 1;
  const themeImage = template.themeImages[themeIndex];
  const generalFeatures =
    template.variant === "short" ? SHORT_GENERAL_FEATURES : LONG_GENERAL_FEATURES;
  const descriptionText =
    template.variant === "short" ? SHORT_DESCRIPTION : LONG_DESCRIPTION;
  const previewUrl = template.url?.trim();

  return (
    <div className="popup">
      <div className="popup-content">
        <button
          type="button"
          className="close-popup"
          onClick={onClose}
          aria-label="Close popup">
          <span aria-hidden="true">
            <i className="bi bi-x"></i>
          </span>
          
        </button>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-6">
              <Slider {...settings}>
                <div>
                  <div
                    className="imgShow"
                    ref={imgContainerRef}
                    onClick={onOpenFullscreen}
                    style={{
                      cursor: isFullscreen
                        ? "pointer"
                        : "url('https://webapi.entab.info/api/image/ENTAB/public/Images/large-zoom-in.png'), auto",
                    }}>
                    {themeImage && (
                      <img
                        src={themeImage}
                        className="img-fluid main-templete"
                        alt={`Template ${templateCode}`}
                      />
                    )}
                    <button className="zoomImg" onClick={onOpenFullscreen}>
                      <i className="bi bi-zoom-in"></i>
                    </button>
                  </div>
                </div>
                {template.deviceImages.map((src, index) => (
                  <div key={`${template.id}-device-${index}`}>
                    <img
                      src={src}
                      className="img-fluid main-templete"
                      alt={`Template ${templateCode} view`}
                    />
                  </div>
                ))}
              </Slider>
            </div>

            <div className="col-xl-6 content-blk">
              <h3>Template Code: {templateCode}</h3>
              <h4 className="mt-2">{template.headerText}</h4>
              <div className="color-options">
                {template.colorOptions.map((option, index) => (
                  <div
                    key={`${template.id}-color-${index}`}
                    className={
                      colorTheme === String(index + 1)
                        ? `${option.className} active-tab`
                        : option.className
                    }
                    style={{ background: option.gradient }}
                    onClick={() => onColorSelect(String(index + 1))}></div>
                ))}
              </div>

              <h4>Description</h4>
              <p>{descriptionText}</p>

              <h4>General Features</h4>
              <ul className="list-view">
              {generalFeatures.map((feature) => (
                <li key={`${template.id}-${feature.label}`}>
                  <span>
                    <b>{feature.label} </b>
                    {feature.text}
                  </span>
                </li>
              ))}
            </ul>

              {template.variant !== "short" && (
                <>
                  <h4>Performance & Optimization</h4>
                  <ul className="list-view">
                    {PERFORMANCE_FEATURES.map((feature) => (
                      <li key={`${template.id}-perf-${feature.label}`}>
                        <span>
                          <b>{feature.label} </b>
                          {feature.text}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <h4>Functional Features</h4>
                  <ul className="list-view">
                    {FUNCTIONAL_FEATURES.map((feature) => (
                      <li key={`${template.id}-func-${feature.label}`}>
                        <span>
                          <b>{feature.label} </b>
                          {feature.text}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <div className="highlight">
                    <p>
                      The changes will be customized according to requirements.
                      Our approach focuses on flexibility, precision, &amp;
                      efficiency to deliver optimal results.
                    </p>
                  </div>

                  <div className="pages-list">
                    <div className="table-list">
                      <h4>Dynamic Sections</h4>
                      <ul className="list-view">
                        {DYNAMIC_SECTIONS.map((item) => (
                          <li key={`${template.id}-dyn-${item}`}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="table-list">
                      <h4>Static Sections</h4>
                      <ul className="list-view">
                        {STATIC_SECTIONS.map((item) => (
                          <li key={`${template.id}-stat-${item}`}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </>
              )}

              <p className="mt-4">
                <i className="bi bi-clock-fill"></i> Required Time: 3 Days
              </p>
              <button type="button" className="btn btn-secondary mt-2" onClick={onClose}>
                Close Popup
              </button>
            </div>

            {previewUrl && (
              <a
                href={previewUrl}
                target="_blank"
                rel="noreferrer"
                className="preview-button">
                Live Preview
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatePopup;
